var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 21.28 2.06 C 20.71 1.49 20.03 1.03 19.29 0.73 C 18.54 0.42 17.74 0.26 16.94 0.26 C 16.13 0.26 15.33 0.42 14.59 0.73 C 13.84 1.04 13.17 1.49 12.6 2.06 L 11.81 2.84 L 11.03 2.06 C 10.46 1.48 9.78 1.01 9.03 0.69 C 8.28 0.37 7.47 0.2 6.66 0.2 C 5.85 0.19 5.04 0.35 4.28 0.66 C 3.53 0.97 2.84 1.42 2.26 2 C 1.68 2.58 1.23 3.26 0.92 4.01 C 0.61 4.76 0.45 5.57 0.46 6.39 C 0.47 7.2 0.63 8.01 0.95 8.76 C 1.27 9.51 1.73 10.19 2.31 10.76 L 10.21 18.66 C 10.63 19.08 11.2 19.31 11.8 19.31 C 12.39 19.31 12.96 19.08 13.39 18.66 L 21.29 10.76 C 22.44 9.6 23.09 8.04 23.09 6.41 C 23.08 4.78 22.43 3.21 21.28 2.06 Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeFilled);
export default __webpack_public_path__ + "static/media/likeFilled.aca91e28.svg";
export { ForwardRef as ReactComponent };